import React, { useMemo } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { App, Button, Card, Space } from 'antd';
import { PartitionOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import PageHeader from 'components/headings/PageHeader';
import ComponentInstanceTree from 'pages/liftlogic/v2/Components/ComponentInstanceTree';
import useComponentInstancesApi from 'pages/liftlogic/v2/Components/useComponentInstancesApi';
import useComponentAttributeDefsApi from 'pages/liftlogic/v2/Components/useComponentAttributeDefsApi';
import useComponentTemplatesApi from 'pages/liftlogic/v2/Components/useComponentTemplatesApi';
import useComponentTypesApi from 'pages/liftlogic/v2/Components/useComponentTypesApi';

function TenantAscensorComponentsPage() {
  const { tenantId: tenantParam, equipoId } = useParams();
  const tenantId = Number(tenantParam);
  const navigate = useNavigate();
  const location = useLocation();
  const equipo = location.state?.equipo;
  const tenantName = location.state?.tenantName || `Tenant ${tenantId}`;

  const rawApi = useComponentInstancesApi();
  const rawDefs = useComponentAttributeDefsApi();
  const rawTemplates = useComponentTemplatesApi();
  const rawTypes = useComponentTypesApi();

  const api = useMemo(
    () => ({
      getTree: (eqId) => rawApi.getTree(tenantId, eqId),
      addNode: (eqId, payload) => rawApi.addNode(tenantId, eqId, payload),
      updateNode: (nodeId, payload) => rawApi.updateNode(tenantId, nodeId, payload),
      removeNode: (nodeId) => rawApi.removeNode(tenantId, nodeId),
      cloneTemplate: (eqId, rootId) => rawApi.cloneTemplate(tenantId, eqId, rootId),
      replaceComponent: (nodeId, payload) =>
        rawApi.replaceComponent(tenantId, equipoId, nodeId, payload),
      listReplacements: (nodeId) => rawApi.listReplacements(tenantId, equipoId, nodeId),
    }),
    [rawApi, tenantId, equipoId]
  );

  const defsApi = useMemo(() => ({ list: () => rawDefs.list() }), [rawDefs]);

  const templatesApi = useMemo(
    () => ({ listRoots: () => rawTemplates.listRoots() }),
    [rawTemplates]
  );

  const typesApi = useMemo(() => ({ list: () => rawTypes.list() }), [rawTypes]);

  return (
    <App>
      <div style={{ padding: 16 }}>
        <PageHeader
          icon={PartitionOutlined}
          title={`Componentes — ${equipo?.nombre || 'equipo'}`}
          subtitle={`Tenant: ${tenantName}`}
          actions={
            <Space>
              <Button
                icon={<ArrowLeftOutlined />}
                onClick={() =>
                  navigate(`/admin/tenants/${tenantId}/equipos`, { state: location.state })
                }
              >
                Volver a equipos
              </Button>
            </Space>
          }
        />
        <Card>
          <ComponentInstanceTree
            api={api}
            defsApi={defsApi}
            templatesApi={templatesApi}
            typesApi={typesApi}
            canEdit
            equipoId={equipoId}
            splitInspector
          />
        </Card>
      </div>
    </App>
  );
}

export default TenantAscensorComponentsPage;
